import { CommonResponseModel, departmentIdReq, EmployeeId, PlantIdReq} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class EmployeeService extends CommonAxiosService {
    private EmployeeController = "/employee";

    async createEmployee(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/createEmployee", payload)
    }

    async getAllEmployee(req?:departmentIdReq): Promise<CommonResponseModel> {
        // console.log(req,'-------------')
        return this.axiosPostCall(this.EmployeeController + "/getAllEmployee",req)
    }

    async getActiveAllEmployee(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/getActiveAllEmployee")
    }
    async updateEmployee(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.EmployeeController + '/updateEmployee', dto)
    }

    async activateOrDeactivateEmployee(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/activateOrDeactivateEmployee", payload)
    }
    async getEmployeeDashBoard(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/getEmployeeDashBoard")
    }
    async getHods(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/getHods")
    }
    async getNonHods(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/getNonHods")
    }

    async getEmployeeById(dto:EmployeeId): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/getEmployeeById",dto)
    }

    async saveOrder(data: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/saveOrder",data)
    }

    async getNonHodsByPlant(req:PlantIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.EmployeeController + "/getNonHodsByPlant",req)
    }
}

